import { render, staticRenderFns } from "./cotizar.vue?vue&type=template&id=60498996"
import script from "./cotizar.vue?vue&type=script&lang=js"
export * from "./cotizar.vue?vue&type=script&lang=js"
import style0 from "./cotizar.vue?vue&type=style&index=0&id=60498996&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports